import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PenLine, Database } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const FloatingAdminPanel = ({ isAdmin = false }: { isAdmin?: boolean }) => {
  const location = useLocation();
  
  const isAdminBlog = location.pathname === "/admin/blog";
  const isAdminPage = location.pathname === "/admin";
  
  if (isAdminPage) {
    return null;
  }

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 animate-fade-in">
      {isAdmin && !isAdminBlog && (
        <Tooltip>
          <TooltipTrigger asChild>
            <Link to="/admin/blog">
              <Button
                variant="outline"
                size="icon"
                className="h-12 w-12 rounded-full glass-card border-white/20 hover:bg-white/20 shadow-lg"
              >
                <PenLine className="h-5 w-5" />
              </Button>
            </Link>
          </TooltipTrigger>
          <TooltipContent side="left">
            <p>Zarządzaj blogiem</p>
          </TooltipContent>
        </Tooltip>
      )}

      <Tooltip>
        <TooltipTrigger asChild>
          <Link to="/admin" onClick={() => localStorage.setItem("admin_return_path", location.pathname)}>
            <Button
              variant="outline"
              size="icon"
              className="h-12 w-12 rounded-full glass-card border-white/20 hover:bg-white/20 shadow-lg"
            >
              <Database className="h-5 w-5" />
            </Button>
          </Link>
        </TooltipTrigger>
        <TooltipContent side="left">
          <p>Panel administratora</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};

export default FloatingAdminPanel;
